import * as React from 'react';
import { useDsRouteParams } from '../../hooks/useDsRouteParams';
import { SiteLoader } from '../ui/loaders/SiteLoader';

interface ITemplateLoaderProps {
  text?: string;
}

export const TemplateLoader: React.FC<ITemplateLoaderProps> = ({ text = '' }) => {
  const { version } = useDsRouteParams();

  const loaderText =
    text !== '' ? text : !!version ? 'Vennligst vent..' : 'Henter oppdatert data..';

  return <SiteLoader text={loaderText} />;
};
